var cssjs = require('jotform-css.js').cssjs;

module.exports = function addPrefix(source, themeName, prefix) {
  if (prefix === void 0) {
    prefix = '.codeblock-theme-';
  }

  var parser = new cssjs();
  var parsed = parser.parseCSS(source);
  var fullPrefix = "" + prefix + themeName;
  var header = "/* prefix \"" + fullPrefix + "\" added by @codeblock/themes */";
  var namespaced = parser.applyNamespacing(parsed, fullPrefix);
  var prefixedCss = parser.getCSSForEditor(namespaced) // see https://github.com/jotform/css.js/issues/28
  .replace(/svg\+xml;\n    /, 'svg+xml;');
  return header + "\n" + prefixedCss;
};